<template>
  <div class="one-news-create">
    <oneNewsLayout>
      <b-form>
        <b-form-group
          label="標題"
          label-for="one-news-create-title"
          class="required-icon-star"
        >
          <b-form-input
            id="one-news-create-title"
            v-model="createForm.news_title"
            :state="verifyTitle"
            :title="'請輸入值'"
            type="text"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="發布日期" class="required-icon-star">
          <b-form-datepicker
            v-model="createForm.released_at"
            :state="verifyDate"
            :title="'請輸入值'"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            }"
            placeholder="請選擇新聞發布日期，非此刻新增日期"
          >
          </b-form-datepicker>
        </b-form-group>
        <b-form-group
          label="內容"
          label-for="one-news-create-content"
          class="required-icon-star"
        >
          <b-form-textarea
            id="one-news-create-content"
            v-model="createForm.news_content"
            :state="verifyContent"
            :title="'輸入格式有誤'"
            rows="15"
          ></b-form-textarea>
        </b-form-group>
        <b-form-group
          label="附件 ( 總容量上限 2048 KB )"
          label-for="one-news-create-files"
        >
          <p>
            <span>目前容量：{{ sumOfSize }} KB</span>
            <span v-if="sumOfSize > maxSize" class="warn">超過上限</span>
          </p>
          <input
            id="one-news-create-files"
            type="file"
            multiple
            accept=".png,.pdf,.txt,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            @change="handleFiles($event)"
          />
        </b-form-group>
        <!-- <div v-if="fileList.length > 0">
          <ul
            v-for="(file, index) in fileList"
            :key="index"
          >
            <li>{{ file.name }} / {{ file.size / 1024 }} KB</li>
          </ul>
        </div> -->
        <div class="text-right">
          <b-button
            class="mr-3"
            type="button"
            variant="primary"
            @click="verifyForm"
            :disabled="isSubmitting"
            >新增</b-button
          >
          <b-button
            class="mr-3"
            type="button"
            variant="dark"
            @click="$router.push({ name: 'news-owner' })"
            >取消</b-button
          >
        </div>
      </b-form>
    </oneNewsLayout>
  </div>
</template>

<script>
import mixinsVerify from "@/utility/mixinsVerify.js";
import oneNewsLayout from "@/layout/OneNewsLayout.vue";
export default {
  mixins: [mixinsVerify],
  components: {
    oneNewsLayout
  },
  data() {
    return {
      createForm: {
        news_title: "",
        released_at: "",
        news_content: ""
      },
      verifyTitle: null,
      verifyDate: null,
      verifyContent: null,
      fileList: [],
      formData: new FormData(),
      isSubmitting: false
    };
  },
  computed: {
    sumOfSize() {
      if (this.fileList.length === 0) return 0;
      let totalSize = 0;
      this.fileList.forEach(file => {
        totalSize += file.size;
      });
      // return KB
      let totalKBSize = totalSize / 1024;
      return totalKBSize.toFixed(2);
    },
    maxSize() {
      //maxSize = 2MB = 2048 KB
      return 2 * 1024;
    }
  },
  methods: {
    verifyForm() {
      this.verifyTitle = this.hasValue(this.createForm.news_title);
      this.verifyDate = this.hasValue(this.createForm.released_at);
      this.verifyContent =
        this.hasValue(this.createForm.news_content) &&
        this.introductionRegexp(this.createForm.news_content);
      if (
        this.verifyTitle === false ||
        this.verifyDate === false ||
        this.verifyContent === false ||
        this.sumOfSize > this.maxSize
      )
        return;
      else this.submit();
    },
    handleFiles(event) {
      this.fileList = [...event.target.files];
      if (this.fileList.length === 0 || this.formData.has("file[]")) {
        this.formData.delete("file[]");
      }
      this.fileList.forEach(file => {
        this.formData.append("file[]", file);
      });
    },
    handleFormData() {
      Object.keys(this.createForm).forEach(key => {
        if (key.includes("released_at")) {
          //from YYYY-MM-DD format to YYYY/MM/DD
          let regex = /-/gi;
          const dateFormat = this.createForm[key].replace(regex, "/");
          this.formData.append(key, dateFormat);
        } else {
          this.formData.append(key, this.createForm[key]);
        }
      });
    },
    submit() {
      this.handleFormData();
      this.isSubmitting = true;
      this.$store.dispatch("createOneNews", this.formData).then(() => {
        alert("新增成功");
        this.$router.push({ name: "news-owner" });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.one-news-create {
  .warn {
    display: inline-block;
    margin-left: 20px;
    color: red;
  }
}
</style>
